/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 일정 확인 모달 헤더
 * 버전 : 1.0
 * 파일명 : ModalTitleScheduleDetail.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * 수정 : 2025-07-07, 강동형 : 저작권 추가, 버튼 비활성화 로직 추가
 * ================================================================ */

import { Divider } from '@mui/material'
import styled from 'styled-components'
import { ActionButton, NextButton } from '../common/CommonStyled'
import { ModalAdSheduleAddStore, useModalStore } from 'src/stores/ModalStore'
import { patchArmyRecruit } from 'src/api/Admin'
import { LoadRecruitSchedule, LoadRecruteDetail } from './useLoadRecruitSchedule'
import { useAdRecruitStore } from 'src/stores/AdRecruitStore'
import { ModalContent_RecruitCalendarDelete, ModalFooter_RecruitCalendarDelete, ModalTitle_RecruitCalendarDelete } from './ModalRecruiteCalendarDelete'

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
`
const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 54px;
    position: absolute;
    right: 0;
`

const ModalTitleScheduleDetail = () => {
  const title = ModalAdSheduleAddStore((state)=>state.title)
  const type = ModalAdSheduleAddStore((state)=>state.type)
  const certification = ModalAdSheduleAddStore((state)=>state.certification)
  const urlLink = ModalAdSheduleAddStore((state)=>state.urlLink)
  const recruitestartdate = ModalAdSheduleAddStore((state)=>state.recruitestartdate)
  const recruiteenddate = ModalAdSheduleAddStore((state)=>state.recruiteenddate)
  const startjob = ModalAdSheduleAddStore((state)=>state.startjob)
  const endjob = ModalAdSheduleAddStore((state)=>state.endjob)
  const etc = ModalAdSheduleAddStore((state)=>state.etc)
  const setField = ModalAdSheduleAddStore((state)=>state.setField)
  const idValue = ModalAdSheduleAddStore((state)=>state.idValue)
  const ismodify = ModalAdSheduleAddStore((state)=>state.ismodify)
 
  const fetchType = useAdRecruitStore((state)=>state.type)
  const status = useAdRecruitStore((state)=>state.status)
  const sort_by = useAdRecruitStore((state)=>state.sort_by)
  const sort_order = useAdRecruitStore((state)=>state.sort_order)
  const page = useAdRecruitStore((state)=>state.page)
  const pageSize = useAdRecruitStore((state)=>state.pageSize)
  const fetchsetField = useAdRecruitStore((state)=>state.setField)
  const modalSetField = useModalStore((state)=>state.setField)

  const onclickPatch = async()=>{
    if(!title) return
    await patchArmyRecruit(
      { 
        announce_id : idValue,
        title : title,
        recruitment_type : type,
        requirements : certification,
        source_url : urlLink,
        application_sdate : recruitestartdate,
        application_edate : recruiteenddate,
        enlistment_date : startjob,
        appointment_date : endjob,
        etc :etc
      })
    setField('ismodify',false)
    const result = await LoadRecruitSchedule(
        { 
            recruitmentType : fetchType,
            status : status,
            sort_by : sort_by,
            sort_order : sort_order,
            page : page,
            size : pageSize
        }
    );
    fetchsetField('recruitScheduleData',result.data)
    fetchsetField('totalPage',result.totalPage)

    const recall = await LoadRecruteDetail(idValue!)
    setField('returnData',recall)
  }

  const onClickCancle = ()=>{
      setField('ismodify',false)
  }

  const item = {
    title: title,
    start: recruitestartdate ? new Date(recruitestartdate) : new Date(),
    end: recruiteenddate ? new Date(recruiteenddate) : new Date(),
    announce_id: idValue ? idValue : 0,
    course_type: type,
    course_name: ''
  }

  const onClickDelete = async ()=>{
      modalSetField('title',<ModalTitle_RecruitCalendarDelete item={item}/>)
      modalSetField('content',<ModalContent_RecruitCalendarDelete/>)
      modalSetField('footer',<ModalFooter_RecruitCalendarDelete item={item}/>)
  }

  return (
    <>
    <PageWrapper>
      {ismodify && 
        <ActionButton style={{width:'94px', height:'54px', position:'absolute',left:0}} onClick={onClickDelete}>삭제</ActionButton>
      }
        모집 일정
        <ButtonWrapper>
          {ismodify ?
            <>
              <ActionButton style={{width:'94px',height: '54px'}} onClick={onClickCancle}>취소</ActionButton>   
              <NextButton style={{width:'94px', height:'100%'}} onClick={onclickPatch}>완료</NextButton>
            </>
            :
            <>
              <ActionButton style={{width:'94px',height: '54px'}} onClick={()=>setField('ismodify',true)}>수정</ActionButton>
              <NextButton style={{width:'94px', height:'100%'}} onClick={()=>modalSetField('open',false)}>닫기</NextButton>
            </>
            }
        </ButtonWrapper>
    </PageWrapper>
    <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
    </>
  )
}

export default ModalTitleScheduleDetail